import { combineReducers } from 'redux';

import consultaAreas from './consultaAreas/reducer';
import assuntos from './assuntos/reducer';

export default combineReducers({
	consultaAreas,
	assuntos,
});
